import request from '@/util/request';
import qs from 'qs';

export const getDetailList = (params, options) =>
request.get('/api/v4ward/valueTypeDetail/page', Object.assign({}, options, { params }));

export const getDetailDetail = (params, options) =>
request.get('/api/v4ward/valueTypeDetail/detail', Object.assign({}, options, { params }))

export const removeDetail = (params, options) =>
request.post('/api/v4ward/valueTypeDetail/remove', qs.stringify(params),options);

export const addDetail = (params, options) =>
request.post('/api/v4ward/valueTypeDetail/save', params,options)

export const updateDetail = (params, options) =>
request.post('/api/v4ward/valueTypeDetail/update', params,options)


export const getMenuTree = (projectId) => {
  return request({
    url: '/api/v4ward/valueTypeMenu/tree',
    method: 'get',
    params: {
      projectId,
    },
  });
};


export const getMenuLazyTree = (projectId,parentId) => {
  return request({
    url: '/api/v4ward/valueTypeMenu/lazy-tree',
    method: 'get',
    params: {
      projectId,
      parentId,
    },
  });
};

export const getMenuList = (params, options) =>
  request.get('/api/v4ward/valueTypeMenu/page', Object.assign({}, options, { params }));

export const getMenuDetail = (params, options) =>
  request.get('/api/v4ward/valueTypeMenu/detail', Object.assign({}, options, { params }))

export const removeMenu = (params, options) =>
  request.post('/api/v4ward/valueTypeMenu/remove', qs.stringify(params),options);

export const addMenu = (params, options) =>
  request.post('/api/v4ward/valueTypeMenu/save', params,options)

export const updateMenu = (params, options) =>
  request.post('/api/v4ward/valueTypeMenu/update', params,options)

  
// 字典
export const getDictionary = (params, options) =>
request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }))

export const getValueTypeMenuList = (params, options) =>
  request.get('/api/v4ward/valueTypeMenu/getValueTypeMenuList', Object.assign({}, options, { params }));

export const menuTree = (params, options) =>
  request.get('/api/v4ward/valueTypeMenu/menuTree', Object.assign({}, options, { params }));

export const menuTreeDetail = (params, options) =>
  request.get('/api/v4ward/valueTypeMenu/detail', Object.assign({}, options, { params }));


